'use strict';

/**
 * True when redirectUrl points at the storefront login page.
 * SEO aliases (e.g. NaturesMenu-d2c → /login) do not contain "Login-Show".
 * @param {string} url
 * @returns {boolean}
 */
function isLoginRedirectUrl(url) {
    var value = String(url || '');
    if (!value) {
        return false;
    }
    if (value.indexOf('Login-Show') !== -1) {
        return true;
    }
    // Auth-guard redirects always append tl=1 (see getLoginShowUrl).
    if (value.indexOf('tl=1') !== -1) {
        return true;
    }
    // Pipeline alias for Login-Show on NaturesMenu-d2c is "login".
    if (/\/login(?:\?|#|$)/i.test(value)) {
        return true;
    }
    return false;
}

/**
 * Follows login redirects from account-protected AJAX endpoints.
 * Covers validateLoggedInAjax ({ loggedin: false, redirectUrl }) and SOR-style
 * JSON ({ redirectUrl: '...Login-Show...' }). Does not follow business redirects
 * such as post-save navigations to Account-Show / Cart-Show.
 * @param {Object} data - parsed JSON response body
 * @returns {boolean} true when a redirect was triggered
 */
function followLoginRedirect(data) {
    if (!data) {
        return false;
    }

    if (typeof data === 'string') {
        var trimmed = data.replace(/^\s+/, '');
        if (trimmed.charAt(0) !== '{' && trimmed.charAt(0) !== '[') {
            return false;
        }
        try {
            data = JSON.parse(trimmed);
        } catch (e) {
            return false;
        }
    }

    if (!data.redirectUrl) {
        return false;
    }

    // Successful business responses may include login URLs (e.g. password-reset
    // returnUrl) — never treat those as forced auth redirects.
    if (data.success === true) {
        return false;
    }

    if (data.loggedin === false || isLoginRedirectUrl(data.redirectUrl)) {
        window.location.href = data.redirectUrl;
        return true;
    }

    return false;
}

/**
 * Binds a document-level ajaxComplete listener so any protected AJAX call that
 * returns a login redirect is followed, regardless of the local success/error handler.
 */
function bindAjaxLoginRedirect() {
    $(document).off('ajaxComplete.nmLoginRedirect').on('ajaxComplete.nmLoginRedirect', function (event, xhr) {
        var data = xhr.responseJSON;
        if (!data && xhr.responseText) {
            try {
                data = JSON.parse(xhr.responseText);
            } catch (e) {
                return;
            }
        }
        followLoginRedirect(data);
    });
}

/**
 * processInclude-compatible initializer (global bind from main.js).
 */
function init() {
    bindAjaxLoginRedirect();
}

module.exports = init;
module.exports.followLoginRedirect = followLoginRedirect;
module.exports.bindAjaxLoginRedirect = bindAjaxLoginRedirect;
module.exports.isLoginRedirectUrl = isLoginRedirectUrl;
